<template>
    <section class="min-h-[85vh] bg-white align-middle flex flex-col justify-center bg-gray">
      <div class="max-w-screen mx-auto px-4 flex flex-wrap py-12 my-6 justify-center">
        <img src="@/assets/trip/img/logo.svg">
      </div>
    </section>
  </template>
  <script>
  export default {
    name: "CancelPage",
    computed: {
    },
    data() {
      return {};
    },
    components: {},
    methods: {},
  };
  </script>
  